// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "*[data-v-532f3c97]{margin:0;padding:0}.element[data-v-532f3c97]{width:100vw;height:100vh;overflow:hidden}.element[data-v-532f3c97]::-webkit-scrollbar{width:0!important}.element[data-v-532f3c97]{-ms-overflow-style:none;overflow:-moz-scrollbars-none}", ""]);
// Exports
module.exports = exports;
